import { NotificationsComponent } from "./notifications.component";

import { AddNotificationsComponent } from "./add-notifications/add-notifications.component";
import { EditNotificationsComponent } from "./edit-notifications/edit-notifications.component";
import { ViewNotificationsComponent } from "./view-notifications/view-notifications.component";

import { AlertConfigurationComponent } from "./alert-configuration/alert-configuration.component";
import { EmailConfigurationComponent } from "./email-configuration/email-configuration.component";
import { MobileConfigurationComponent } from "./mobile-configuration/mobile-configuration.component";
import { ManageGroupComponent } from "./manage-group/manage-group.component";
import { ManageGroupAddFormComponent } from "./directives/manage-group-add-form/manage-group-add-form.component";
import { ManageGroupVerificationComponent } from "./directives/manage-group-verification/manage-group-verification.component";
import { NotificationFormComponent } from "./directives/notification-form/notification-form.component";

export const NotificationsDeclaration=[
    NotificationsComponent,

    AddNotificationsComponent,
    EditNotificationsComponent,
    ViewNotificationsComponent,

    AlertConfigurationComponent,
    MobileConfigurationComponent,
    EmailConfigurationComponent,
    ManageGroupComponent,

    //directives
    NotificationFormComponent,
    ManageGroupAddFormComponent,
    ManageGroupVerificationComponent,
];